import { render, staticRenderFns } from "./DepsDropdown.vue?vue&type=template&id=0dd5b920"
import script from "./DepsDropdown.vue?vue&type=script&lang=js"
export * from "./DepsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports